import React, { useEffect, useState } from "react"
import ArrowUpRed from "../../asset/icon/ArrowUpRed"
import ArrowDownGreen from "../../asset/icon/ArrowDownGreen"
import {
  Card,
  CardItem,
  Frame,
  MainContent,
  MainUnit,
  MainValue,
  SubContent,
  SubContent1,
  SubContent2,
  SubContent3,
  Title,
  Wrapper,
} from "./styeld"
import axios from "axios"
import { CO2_FACTOR } from "../../util/Factor"

interface DashboardData {
  todayGeneration: number
  todayConsumption: number
  yesterdayGeneration: number
  yesterdayConsumption: number
}

interface PercentageData {
  consumption: number
  generation: number
  emissions: number
  reductions: number
}

const CardFrame1 = () => {
  const [data, setData] = useState<DashboardData>({
    todayGeneration: 0,
    todayConsumption: 0,
    yesterdayGeneration: 0,
    yesterdayConsumption: 0,
  })

  const [percentage, setPercentage] = useState<PercentageData>({
    consumption: 0,
    generation: 0,
    emissions: 0,
    reductions: 0,
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/smart-farm/dashboard-day`
        )
        const {
          todayGeneration,
          todayConsumption,
          yesterdayGeneration,
          yesterdayConsumption,
        } = response.data

        const currentHour = new Date().getHours()

        const adjustedYesterdayConsumption =
          (yesterdayConsumption * currentHour) / 24
        const adjustedYesterdayGeneration =
          (yesterdayGeneration * currentHour) / 24

        const todayEmissions = (todayConsumption / 1000) * CO2_FACTOR
        const todayReductions = (todayGeneration / 1000) * CO2_FACTOR

        const yesterdayEmissions =
          (adjustedYesterdayConsumption / 1000) * CO2_FACTOR
        const yesterdayReductions =
          (adjustedYesterdayGeneration / 1000) * CO2_FACTOR

        setData({
          todayGeneration,
          todayConsumption,
          yesterdayGeneration: adjustedYesterdayGeneration,
          yesterdayConsumption: adjustedYesterdayConsumption,
        })

        setPercentage({
          consumption:
            ((todayConsumption - adjustedYesterdayConsumption) /
              adjustedYesterdayConsumption) *
            100,
          generation:
            ((todayGeneration - adjustedYesterdayGeneration) /
              adjustedYesterdayGeneration) *
            100,
          emissions:
            ((todayEmissions - yesterdayEmissions) / yesterdayEmissions) * 100,
          reductions:
            ((todayReductions - yesterdayReductions) / yesterdayReductions) *
            100,
        })
      } catch (error) {
        console.error("Error fetching dashboard data:", error)
      }
    }

    fetchData()
  }, [])

  return (
    <Card>
      <Wrapper>
        <Frame>
          <Title>금일 에너지 사용량</Title>
          <CardItem>
            <MainContent>
              {percentage.consumption >= 0 ? (
                <ArrowUpRed />
              ) : (
                <ArrowDownGreen />
              )}
              <MainValue>
                {Number(data.todayConsumption.toFixed(0)).toLocaleString()}
              </MainValue>
              <MainUnit>kWh</MainUnit>
            </MainContent>
            <SubContent>
              <SubContent1>전일 대비</SubContent1>
              <SubContent2 increase={percentage.consumption >= 0}>
                {Number.isFinite(percentage.consumption)
                  ? percentage.consumption.toFixed(0)
                  : 0}
                %
              </SubContent2>
              <SubContent3 increase={percentage.consumption >= 0}>
                {percentage.consumption >= 0 ? "증가" : "감소"}
              </SubContent3>
            </SubContent>
          </CardItem>
        </Frame>

        <Frame>
          <Title>금일 온실가스 배출량</Title>
          <CardItem>
            <MainContent>
              {percentage.emissions >= 0 ? <ArrowUpRed /> : <ArrowDownGreen />}
              <MainValue>
                {Number(
                  ((data.todayConsumption / 1000) * CO2_FACTOR).toFixed(0)
                ).toLocaleString()}
              </MainValue>
              <MainUnit>tCO2eq</MainUnit>
            </MainContent>
            <SubContent>
              <SubContent1>전일 대비</SubContent1>
              <SubContent2 increase={percentage.emissions >= 0}>
                {Number.isFinite(percentage.emissions)
                  ? percentage.emissions.toFixed(0)
                  : 0}
                %
              </SubContent2>
              <SubContent3 increase={percentage.emissions >= 0}>
                {percentage.emissions >= 0 ? "증가" : "감소"}
              </SubContent3>
            </SubContent>
          </CardItem>
        </Frame>

        <Frame>
          <Title>금일 재생에너지 발전량</Title>
          <CardItem>
            <MainContent>
              {percentage.generation >= 0 ? <ArrowUpRed /> : <ArrowDownGreen />}
              <MainValue>
                {Number(data.todayGeneration.toFixed(0)).toLocaleString()}
              </MainValue>
              <MainUnit>kWh</MainUnit>
            </MainContent>
            <SubContent>
              <SubContent1>전일 대비</SubContent1>
              <SubContent2 increase={percentage.generation >= 0}>
                {Number.isFinite(percentage.generation)
                  ? percentage.generation.toFixed(0)
                  : 0}
                %
              </SubContent2>
              <SubContent3 increase={percentage.generation >= 0}>
                {percentage.generation >= 0 ? "증가" : "감소"}
              </SubContent3>
            </SubContent>
          </CardItem>
        </Frame>

        <Frame>
          <Title>금일 온실가스 감축량</Title>
          <CardItem>
            <MainContent>
              {percentage.reductions >= 0 ? <ArrowUpRed /> : <ArrowDownGreen />}
              <MainValue>
                {Number(
                  ((data.todayGeneration / 1000) * CO2_FACTOR).toFixed(0)
                ).toLocaleString()}
              </MainValue>
              <MainUnit>tCO2eq</MainUnit>
            </MainContent>
            <SubContent>
              <SubContent1>전일 대비</SubContent1>
              <SubContent2 increase={percentage.reductions >= 0}>
                {Number.isFinite(percentage.reductions)
                  ? percentage.reductions.toFixed(0)
                  : 0}
                %
              </SubContent2>
              <SubContent3 increase={percentage.reductions >= 0}>
                {percentage.reductions >= 0 ? "증가" : "감소"}
              </SubContent3>
            </SubContent>
          </CardItem>
        </Frame>
      </Wrapper>
    </Card>
  )
}

export default CardFrame1
